import * as Sentry from '@sentry/nuxt'
import { beforeSend, featureFlagsIntegration } from '~/utils/errors'

const { enabled, dsn, environment, tracesSampleRate } =
  useRuntimeConfig().public.sentry

if (!enabled) {
  console.warn('Sentry is disabled, skipping Sentry client plugin')
} else if (!dsn) {
  console.warn('Sentry DSN not set, skipping Sentry initialization')
} else {
  Sentry.init({
    beforeSend,
    dsn,
    environment,
    tracesSampleRate: tryParseFloat(tracesSampleRate) ?? 0.1,
    replaysSessionSampleRate: 0, // no need to store all session replay, only on errors
    replaysOnErrorSampleRate: 0.3,

    denyUrls: [
      /clarity\.ms/i,
      /google/i,
      /bugherd\.com/i,
      /sentry\.io/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],

    // If you don't want to use Session Replay, just remove the line below:
    integrations: [
      Sentry.browserTracingIntegration({ router: useRouter() }),
      Sentry.replayIntegration(),
      featureFlagsIntegration(),
    ],

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: !!import.meta.dev,

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
  })
}
